import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'//element-ui语言包
import enLocale from 'element-ui/lib/locale/lang/en'//element-ui语言包
import ElementLocale from 'element-ui/lib/locale'

Vue.use(VueI18n)

// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = new VueI18n({
  locale: sessionStorage.getItem('language')||'zh_cn',
  messages: {
    'zh_cn': {
      ...require('@/assets/languages/zh_cn.json'),//自定义语言包
      ...zhLocale//element-ui语言包
    },
    'en_us': {
      ...require('@/assets/languages/en_us.json'),//自定义语言包
      ...enLocale//element-ui语言包
    }
  }
})

ElementLocale.i18n((key,value) => i18n.t(key,value))

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js